import { render } from "./SummaryPage.vue?vue&type=template&id=06f832f7&scoped=true"
import script from "./SummaryPage.vue?vue&type=script&lang=js"
export * from "./SummaryPage.vue?vue&type=script&lang=js"

import "./SummaryPage.vue?vue&type=style&index=0&id=06f832f7&scoped=true&lang=css"

import exportComponent from "/var/www/html/pengadaan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06f832f7"]])

export default __exports__